module.exports = __webpack_public_path__ + "static/media/bjc_founders.4f9ea67f.jpg";